<template> <!--https://vuetifyjs.com/en/api/v-autocomplete/-->
	<v-autocomplete
		:items="items"
		:label="label"
		:item-text="itemText"
		:item-value="itemValue"
		:dense="dense"
		:chips="multiple"
		:multiple="multiple"
		:disabled="disabled"
		:color="ada.blue"
		flat
		:auto-select-first="true"
		:menu-props="menuProps"
		:return-object="returnObject"
		no-data-text="Keine Daten"
		@change="emitChange"
		v-bind:value="value"
		v-on:input="$emit('input', $event)"
		v-on:blur="$emit('blur', $event)"
		:required="required"
		:error-messages="errorMessages"
		:placeholder="placeholder"
		:loading="loading"
		:clearable="clearable"
		:search-input.sync="search"
		v-bind="$attrs"
	>
		<template v-if="multiple" v-slot:selection="data">
			<v-chip
				v-bind="data.attrs"
				label
				:color="ada.lightGrey"
				:input-value="data.selected"
				:close="!disabled"
				@click="data.select"
				@click:close="removeSize(data.item)"
			>
				{{ data.item[itemText] }}
			</v-chip>
		</template>
		<template v-slot:item="data">
			<slot v-if="customTemplate" name="customItemTemplate" v-bind:item="data.value"></slot>
			<span v-else>{{ data.item[itemText] }}</span>
		</template>
		<template #append-outer>
			<slot name="append-outer"></slot>
		</template>
	</v-autocomplete>
</template>

<script>
import ada from "../../scss/ada_colors.scss";

export default {
	name: "Dropdown",
	props: {
		items: {
			required: true
		},
		label: {
			type: String,
			default: ''
		},
		itemText: {
			type: String,       //propertyName of items’s text value
			default: 'text'
		},
		itemValue: {
			type: String,       //propertyName of items’s value
			default: 'value'
		},
		dense: {type: Boolean, default: false},
		multiple: {type: Boolean, default: false},
		loading: {type: Boolean, default: false},
		disabled: {type: Boolean, default: false},
		value: [String, Array, Object, Number],
		required: {type: Boolean, default: false},
		errorMessages: {required: false},
		placeholder: {required: false},
		clearable: {type: Boolean, default: false},
		customTemplate: {type: Boolean, default: false},
		returnObject: {type: Boolean, default: true}
	},
	data: () => {
		return {
			ada,
			search: '',
			menuProps: {
				allowOverflow: true,
			}
		}
	},
	methods: {
		parseData(name) {
			let ret = name.replaceAll('&nbsp;', '');
			ret = name.replaceAll('&raquo;', '');
			ret = name.replaceAll('&raquo; ', '');
			return ret;
		},
		removeSize(item) {
			const copy = [...this.value];
			let index = copy.findIndex(x => x[this.itemValue] === item[this.itemValue]);
			if (index >= 0) copy.splice(index, 1);
			this.$emit('input', copy);
		},
		emitChange(event) {
			this.search = '';
			this.$emit('change', event);
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .mdi-close-circle::before {
	color: #a6afb5;
}

::v-deep .v-text-field.v-select--chips {
	.v-label {
		top: 12px;
	}

	.v-label--active {
		transform: translateY(-26px) scale(0.75);
	}
}
</style>